<script lang="ts">
    import { Link } from "svelte-navigator";
    let y
    $: alpha = y > 0 ? 0.682 : 0;
</script>

<svelte:window bind:scrollY={y} />

<div class="nav-div" style="background-color:rgba(27, 27, 27, {alpha})">
    <div class="nav-title">
        <h1>Kari Kytö</h1>
        <!-- <a href="https://www.instagram.com/kari57.kyto" class="fa fa-instagram" /> -->
    </div>
    <div class="nav-button">
        <Link to="/">Etusivu</Link>
        <Link to="linnut">Linnut</Link>
        <Link to="galleriat">Galleriat</Link>
        <Link to="matkat">Matkat</Link>
        <Link to="viikonkuva">Viikon Kuva</Link>
        <Link to="kuukaudenkuva">Kuukauden Kuva</Link>
    </div>
    <div class="nav-link">
        <a href="https://www.instagram.com/kari57.kyto" class="fa fa-instagram" />
    </div>
</div>

<style>
    .nav-div {
        top: 0px;
        right: 0px;
        width: 100%;
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        transition-duration: 0.35s;
        /* background: rgb(105,163,93); */
        /* background: linear-gradient(0deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%); */
        /* border-bottom: 1px solid #d1d1d1; */
    }

    .nav-button {
        z-index: 1;
        display: flex;
        justify-content: center;
        width: 100%;
        top: 0px;
        right: 0px;
    }

    .nav-title {
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0px;
        padding-bottom: 0;
        margin-bottom: 0;
        margin-left: 25px;
        margin-right: auto;
    }

    .nav-title h1{
        width: 130px;
        font-size: x-large;
        font-weight: bold;
        align-items: center;
        padding: 0px;
        margin: 0px;
        color: rgb(31, 31, 31);
    }

    .nav-link {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: auto;
        margin-right: 25px;
    }

    :global(.nav-button a) {
        font-size: large;
        padding: 15px 15px;
        text-decoration: none;
        font-weight: bold;
        color: rgb(24, 24, 24);
    }

    :global(.nav-button a:hover) {
        color: rgb(168, 169, 255);
    }

    :global(.nav-button a[aria-current]) {
        border-bottom: 3px solid rgb(168, 169, 255);
        color: rgb(168, 169, 255);
    }

    .fa {
        font-size: 30px;
        text-align: center;
        text-decoration: none;
        padding: 3px 5px;
        border-radius: 10px;
        color: white;
        background: radial-gradient(circle farthest-corner at 35% 90%, #fec564, transparent 50%), radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%), radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent), linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%);
    }

    /* Add a hover effect if you want */
    .fa:hover {
        opacity: 0.7;
    }
</style>
